import { useEffect, useState } from "react"
import { Alert, Box } from "@mui/material"
import type { ProdutoCatalogo } from "@/api"
import { AvisoPassoIndisponivel } from "@/components/aviso-passo-indisponivel"
import { ConteudoDetalheProduto, DialogDetalhe } from "@/components/detalhe-produto"
import { capitalize, formatarBRL } from "@/lib/formato"
import { convitePorQuantidade } from "@/lib/itens-pedido"
import { precoPorQuantidade } from "@/lib/preco-por-quantidade"
import { passoObrigatorioIndisponivel, temPassos } from "./passos"

export interface EscolhaDoDetalhe {
    quantidade: number
    observacao: string
}

interface DialogDetalheProdutoProps {
    produto: ProdutoCatalogo | null
    aparelho: 'tablet' | 'totem'
    onFechar: () => void
    onConfirmar: (escolha: EscolhaDoDetalhe) => void
}

export default function DialogDetalheProduto({ produto, aparelho, onFechar, onConfirmar }: DialogDetalheProdutoProps): JSX.Element {
    const [quantidade, setQuantidade] = useState(1)
    const [observacao, setObservacao] = useState('')

    useEffect(() => {
        setQuantidade(1)
        setObservacao('')
    }, [produto?.id])

    return (
        <DialogDetalhe aberto={!!produto} aoFechar={onFechar} titulo="Detalhes do item" formato={aparelho}>
            {produto && (
                <Conteudo
                    produto={produto}
                    aparelho={aparelho}
                    quantidade={quantidade}
                    aoMudarQuantidade={setQuantidade}
                    observacao={observacao}
                    aoMudarObservacao={setObservacao}
                    aoConfirmar={() => onConfirmar({ quantidade, observacao: observacao.trim() })}
                />
            )}
        </DialogDetalhe>
    )
}

interface ConteudoProps {
    produto: ProdutoCatalogo
    aparelho: 'tablet' | 'totem'
    quantidade: number
    aoMudarQuantidade: (quantidade: number) => void
    observacao: string
    aoMudarObservacao: (observacao: string) => void
    aoConfirmar: () => void
}

function Conteudo({ produto, aparelho, quantidade, aoMudarQuantidade, observacao, aoMudarObservacao, aoConfirmar }: ConteudoProps): JSX.Element {
    const comOpcoes = temPassos(produto)
    const passoBloqueado = passoObrigatorioIndisponivel(produto)
    const unitario = precoPorQuantidade(produto.faixasPreco, quantidade, produto.valor)
    const convite = convitePorQuantidade({ faixasPreco: produto.faixasPreco, quantidade, precoUnitario: unitario })

    return (
        <ConteudoDetalheProduto
            produto={produto}
            formato={aparelho}
            observacao={comOpcoes ? undefined : { valor: observacao, aoMudar: aoMudarObservacao }}
            quantidade={quantidade}
            aoMudarQuantidade={aoMudarQuantidade}
            convite={convite}
            acao={{
                rotulo: comOpcoes ? 'Escolher opções' : `Adicionar · ${formatarBRL(unitario * quantidade)}`,
                desabilitada: !!passoBloqueado,
                aoAcionar: aoConfirmar,
            }}
        >
            {comOpcoes && (
                <Box sx={{ mt: aparelho === 'totem' ? 3 : 2 }}>
                    {passoBloqueado ? (
                        <AvisoPassoIndisponivel nomeProduto={capitalize(produto.descricao)} passo={passoBloqueado} whatsapp={null} />
                    ) : (
                        <Alert severity="info">
                            Este produto possui adicionais. Clique em <strong>Escolher opções</strong> para montar seu pedido.
                        </Alert>
                    )}
                </Box>
            )}
        </ConteudoDetalheProduto>
    )
}
